import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTableV2";

function Visualize({ user }) {
    const [userParks, setUserParks] = useState([]);

    useEffect(() => {
        setUserParks(user.parks);
    }, [user]);

    const formatPhoneNumber = (phone) => {
        if (!phone) return "";

        // Supprimer tous les caractères non numériques
        let cleaned = phone.replace(/\D/g, "");
        // Si le numéro commence par 0033, on retire les 4 premiers caractères
        if (cleaned.startsWith("0033")) {
            cleaned = cleaned.slice(4);
        }
        // S'assurer de ne garder que les 9 derniers chiffres
        cleaned = cleaned.slice(-9);
        return cleaned;
    };

    if (!user) {
        return <MDTypography variant="h6">Chargement des données utilisateur...</MDTypography>;
    }

    return (
        <MDBox mt={5} pb={3}>
            <Grid container spacing={1}>
                <Grid item xs={24} md={12} xl={6} sx={{ display: "flex" }}>
                    <MDBox display="flex" flexDirection="column" width="100%" px={2}>
                        <MDBox display="flex" width="96%" mb={2} justifyContent="space-between">
                            <MDBox width="48%">
                                <MDInput
                                    type="text"
                                    label="Name"
                                    fullWidth
                                    value={user.lastName}
                                    inputProps={{ readOnly: true, color: "dark" }}
                                />
                            </MDBox>
                            <MDBox width="48%">
                                <MDInput
                                    type="text"
                                    label="First Name"
                                    fullWidth
                                    value={user.name}
                                    inputProps={{ readOnly: true, color: "dark" }}
                                />
                            </MDBox>
                        </MDBox>
                        <MDBox mb={2} width="40%">
                            <MDInput
                                type="tel"
                                label="Phone"
                                fullWidth
                                value={formatPhoneNumber(user.phone)}
                                inputProps={{ readOnly: true, color: "dark" }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Typography variant="caption" color="textSecondary" sx={{ fontSize: "1rem" }}>
                                                +33
                                            </Typography>
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{ shrink: true }}
                            />
                        </MDBox>
                        <MDBox mb={2} width="70%">
                            <MDInput
                                type="email"
                                label="Email"
                                fullWidth
                                value={user.email}
                                inputProps={{ readOnly: true, color: "dark" }}
                            />
                        </MDBox>
                    </MDBox>
                </Grid>
                <Grid item xs={24} md={12} xl={5.8}>
                    <MDBox pt={1} pb={1}>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Card>
                                    <MDBox
                                        mx={2}
                                        mt={-3}
                                        py={1.5}
                                        px={2}
                                        variant="gradient"
                                        bgColor="info"
                                        borderRadius="lg"
                                        coloredShadow="info"
                                    >
                                        <MDTypography variant="h6" color="white">
                                            Park Access
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox pt={3}>
                                        <DataTable
                                            table={{
                                                columns: [
                                                    { Header: "", accessor: "name", align: "left" },
                                                ],
                                                rows: userParks.length === 0
                                                    ? [{
                                                        nameValue: "...",
                                                        name: (
                                                            <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
                                                                ...
                                                            </MDTypography>
                                                        ),
                                                    }]
                                                    : userParks.map((park) => ({
                                                        nameValue: park.name, // Stockage de la valeur simple (entier)

                                                        name: (
                                                            <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
                                                                {park.name}
                                                            </MDTypography>
                                                        ),
                                                    })),
                                            }}
                                            rowsNumberPerPage={5}
                                            isSorted={false}
                                            entriesPerPage={false}
                                            showTotalEntries={false}
                                            noEndBorder
                                        />
                                    </MDBox>
                                </Card>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default Visualize;